import { setupStimulus } from '@blueberry/framework/setup_stimulus'
import { storeAndClearQueryParameters } from './lib/query_param_utils'

setupStimulus(
  import.meta.glob(
    [
      './controllers/*_controller.ts',
      '@blueberry/controllers/modal_controller.ts',
      '@blueberry/controllers/phone_controller.ts',
    ],
    { eager: true },
  ),
)

const FACEBOOK_PROHIBITED_QUERY_PARAMS = ['promo', 'design', 'ref', 'nb_kwd']
storeAndClearQueryParameters(FACEBOOK_PROHIBITED_QUERY_PARAMS)

window.addEventListener("turbo:frame-missing", (response) => {
  const targetFrameId = response.target.id
  response.detail.visit(`/bbjoin/fatal_error?target_frame=${targetFrameId}`, { frame: targetFrameId })
})
